<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    style="margin-top: 12px"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t(`the-finals-boost.the-finals-gadgets-weapons-boost.title`) }}
    </h4>

    <div class="champions_box d-flex-column justify-start align-start">
      <TransitionGroup
        name="list"
        tag="div"
        class="champion_grid_container"
        style="margin-top: 10px"
      >
        <button
          class="champ_button item_button"
          v-for="item in items"
          :key="item"
          @click="() => selectItem(item.slab)"
          :class="[isSelected(item.slab) && 'selected']"
        >
          <h4 class="t-white medium-s font-family-2">
            {{ item.title }}
          </h4>
          <p class="regular-m t-grey font-family-2">
            {{ getUserCurrencyCode }}{{ price(item.price) }}
          </p>
        </button>
      </TransitionGroup>
    </div>
  </div>
</template>

<script>
// import { calculateCurrency } from "../../../../mixins/calculatePrice";
import { calculateCurrency } from "../../../../calculate/calculatePrice";
export default {
  data() {
    return {
      searchQuery: "",
    };
  },

  components: {},
  computed: {
    items() {
      if (!this.checkoutStore.getSelectedRole || !this.getGame) {
        return [];
      }
      const selectedRole = this.getGame.roles?.find(
        (role) => role.id == this.checkoutStore.getSelectedRole
      );
      if (!selectedRole) {
        return [];
      }

      const title = selectedRole.title.toLowerCase();

      const it = this.getGamePack.prices?.filter((price) =>
        price?.description?.includes(title)
      );
      return it;
    },
  },
  beforeMount() {},

  watch: {
    items() {},
    "checkoutStore.getSelectedRole": {
      handler() {
        this.checkoutStore.setDetails({
          gadgetsAndWeapons: [],
        });
      },
      deep: true,
    },
  },

  methods: {
    selectItem(itemSlab) {
      let selectedItems = [...this.checkoutStore.getDetails?.gadgetsAndWeapons];

      if (selectedItems.includes(itemSlab)) {
        selectedItems = selectedItems.filter((item) => item != itemSlab);
      } else {
        selectedItems = [...selectedItems, itemSlab];
      }

      this.checkoutStore.setDetails({
        gadgetsAndWeapons: selectedItems,
      });
    },
    isSelected(slab) {
      if (this.checkoutStore.getDetails?.gadgetsAndWeapons?.includes(slab)) {
        return true;
      }
      return false;
    },
    price(cp) {
      return parseFloat(calculateCurrency(cp)).toFixed(2);
    },
  },
  props: {},
  setup() {
    const { getGame, getGamePack } = useGameStore();
    const { getUserCurrencyCode } = useUserStore();
    const checkoutStore = useCheckoutStore();

    return {
      getGame,
      getGamePack,
      getUserCurrencyCode,
      checkoutStore,
    };
  },
};
</script>
